let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7KDb4")).then(() => parcelRequire('gLLiw'));